$(document).ready(function($) {
    
    function jump_to_slide(slider, navigation, slide_number) {
        console.log('jump_to_slide', slide_number);
        currentSlide = slider.find('input.currentSlide').val();
        var activeColor = slider.find('input.activeColor').val();
        if (currentSlide == slide_number) {
            return;
        } else {
            var distance = Math.abs(currentSlide - slide_number);
            //trigger the click event on the next or prev button
            if (currentSlide < slide_number) {
                navigate_next(slider, navigation, distance);
            } else {
                navigate_prev(slider, navigation, distance);
            }
        }
        navigation.find('.navigation-dots').find('.dot').removeClass('active');
        navigation.find('.navigation-dots').find('.dot:nth-child(' + slide_number + ')').addClass('active');
        slider.find('input.currentSlide').val(slide_number);
    }

    function bind_navigation(slider, navigation) {
        navigation.find('.navigation-dots').on('click', '.dot', function(e){
            // jump_to_slide(slider, navigation, ($(this).index() + 1));
            e.preventDefault();
        });
    }

    function navigate_prev(slider, navigation, distance) {
        if (distance == undefined) {
            distance = 1;
        }
        //move testimonial before the '.prev' to the beginning if the list
        activeColor = slider.find('input.activeColor').val();
        currentSlide = slider.find('input.currentSlide').val();
        if (parseInt(currentSlide) == 1) {
            currentSlide = slider.find('.testimonial-slider-outer-wrap').find('.testimonial').length;
        } else {
            currentSlide = parseInt(currentSlide) - 1;
        }
        slider.find('input.currentSlide').val(currentSlide);
        navigation.find('.navigation-dots').find('.dot').removeClass('active');
        navigation.find('.navigation-dots').find('.dot:nth-child(' + currentSlide + ')').addClass('active');

        var distance_traveled = 0;
        var active_target = slider.find('.testimonial-slider-outer-wrap').find('.prev');
        while (distance_traveled < distance) {
            if (active_target.prev().length) {
                active_target = active_target.prev();
            } else {
                active_target = slider.find('.testimonial-slider-outer-wrap').find('.testimonial:last-child');
            }
            distance_traveled++;
        }
        console.log('active_target', active_target);

        if (activeColor == 'blue') {
            activeColor = 'green';
            active_target.addClass('before').removeClass('green').addClass('blue');
        } else {
            activeColor = 'blue';
            active_target.addClass('before').removeClass('blue').addClass('green');
        }

        
        slider.find('input.activeColor').val(activeColor);
        window.setTimeout(function(){
            slider.find('.testimonial-slider-outer-wrap').find('.before').removeClass('before').addClass('prev completed');
            slider.find('.testimonial-slider-outer-wrap').find('.prev:not(.completed)').removeClass('prev').addClass('active completed');
            slider.find('.testimonial-slider-outer-wrap').find('.active:not(.completed)').removeClass('active').addClass('next completed');
            slider.find('.testimonial-slider-outer-wrap').find('.next:not(.completed)').removeClass('next').addClass('completed');

            window.setTimeout(function(){
                slider.find('.testimonial-slider-outer-wrap').find('.testimonial').removeClass('completed');
                testimonials_shuffling = false;
            }, 300);
        }, 10);
    }

    function navigate_next(slider, navigation, distance) {
        if (distance == undefined) {
            distance = 1;
        }
        activeColor = slider.find('input.activeColor').val();
        currentSlide = slider.find('input.currentSlide').val();
        if (parseInt(currentSlide) == slider.find('.testimonial-slider-outer-wrap').find('.testimonial').length) {
            currentSlide = 1;
        } else {
            currentSlide = parseInt(currentSlide) + 1;
        }
        slider.find('input.currentSlide').val(currentSlide);
        navigation.find('.navigation-dots').find('.dot').removeClass('active');
        navigation.find('.navigation-dots').find('.dot:nth-child(' + currentSlide + ')').addClass('active');
        
        var distance_traveled = 0;
        var active_target = slider.find('.testimonial-slider-outer-wrap').find('.next');
        while (distance_traveled < distance) { 
            if (active_target.next().length) {
                active_target = active_target.next();
            } else {
                active_target = slider.find('.testimonial-slider-outer-wrap').find('.testimonial:first-child');
            }
            distance_traveled++;
        }
        console.log('active_target', active_target);

        if (activeColor == 'blue') {
            activeColor = 'green';
            active_target.removeClass('green').addClass('blue');
        } else {
            activeColor = 'blue';
            active_target.removeClass('blue').addClass('green');
        }
        slider.find('input.activeColor').val(activeColor);
        slider.find('.testimonial-slider-outer-wrap').find('.prev').removeClass('prev').addClass('removed').addClass('completed');
        slider.find('.testimonial-slider-outer-wrap').find('.active:not(.completed)').removeClass('active').addClass('prev completed');
        
        active_target.addClass('next completed');

        slider.find('.testimonial-slider-outer-wrap').find('.next:not(.completed)').removeClass('next').addClass('active completed');
        window.setTimeout(function(){
            slider.find('.testimonial-slider-outer-wrap').find('.testimonial').removeClass('completed').removeClass('removed');
            // slider.find('.testimonial-slider-outer-wrap:not(.active):not(.prev):not(.next)').find('.testimonial').removeClass('blue').removeClass('green');
            testimonials_shuffling = false;
        }, 300);
    }

    var testimonials_shuffling = false;

    function do_nav_next(slider, navigation, distance) {
        if (typeof distance == undefined) {
            distance = 1;
        }
        activeColor = slider.find('input.activeColor').val();
        currentSlide = slider.find('input.currentSlide').val();
        console.log(slider.find('.testimonial-slider-outer-wrap').css('--quantity'));
        if (parseInt(currentSlide) == slider.find('.testimonial-slider-outer-wrap').css('--quantity')) {
            currentSlide = 1;
        } else {
            currentSlide = parseInt(currentSlide) + 1;
        }

        slider.find('input.currentSlide').val(currentSlide);
        navigation.find('.navigation-dots').find('.dot').removeClass('active');
        navigation.find('.navigation-dots').find('.dot:nth-child(' + currentSlide + ')').addClass('active');
        
    }

    function setup_navigation(slider, navigation) {
        navigation.find('.navigation-actions .wp-block-buttons .is-style-back-button').on( 'click', function(e){
            if (!testimonials_shuffling) {
                testimonials_shuffling = true;
                navigate_prev(slider, navigation);
            }
            e.preventDefault();
            e.stopPropagation();
        });
        navigation.find('.navigation-actions .wp-block-buttons .is-style-forward-button').on( 'click', function(e){
            if (!testimonials_shuffling) {
                testimonials_shuffling = true;
                // do_nav_next(slider, navigation);
                navigate_next(slider, navigation);
            }
            e.preventDefault();
            e.stopPropagation();
        });
    }

    $('.testimonial-slider-section').each(function(e){
        var slider = $(this).find('.slider-wrapper');
        var navigation = $(this).find('.slider-navigation');

        bind_navigation(slider, navigation);
        setup_navigation(slider, navigation);
    });
});